import { h } from '../../ui/dom';
import { linkBtn, section } from '../../ui/components';
import { cardLink } from './cardLink';

/** The way into the daily brief (D89), first on the Home so the morning starts at the list rather
 *  than at the pieces. The counts live on the brief itself; this card only points at it. */
export interface BriefCardCounts {
  followUps: number;
  calls: number;
  stops: number;
}

export const briefCard = (counts: BriefCardCounts): HTMLElement => {
  const total = counts.followUps + counts.calls + counts.stops;
  const line = [
    counts.followUps ? `${counts.followUps} follow-up${counts.followUps === 1 ? '' : 's'} due` : '',
    counts.calls ? `${counts.calls} to call` : '',
    counts.stops ? `${counts.stops} stop${counts.stops === 1 ? '' : 's'}` : '',
  ]
    .filter(Boolean)
    .join(' · ');
  return section(
    { title: 'Today’s brief', count: total, action: cardLink('Open', '#/brief') },
    h('p', { class: 'card__summary' }, total === 0 ? 'Nothing waiting — plan a route.' : line),
    h(
      'div',
      { class: 'stack stack--center' },
      linkBtn(total === 0 ? 'Plan tomorrow' : 'Work the brief', total === 0 ? '#/route/plan' : '#/brief', {
        variant: 'primary',
      }),
    ),
  );
};
